import DataSourcesPage from './DataSourcesPage';

export default DataSourcesPage;
